/** 正文外站链接确认弹窗状态 */
import { reactive } from 'vue'

export const externalLinkConfirm = reactive({
  visible: false,
  href: '',
})

export function requestExternalLinkConfirm(href) {
  const url = String(href || '').trim()
  if (!url) return
  externalLinkConfirm.href = url
  externalLinkConfirm.visible = true
}

export function closeExternalLinkConfirm() {
  externalLinkConfirm.visible = false
  externalLinkConfirm.href = ''
}

export function confirmExternalLinkJump() {
  const url = String(externalLinkConfirm.href || '').trim()
  closeExternalLinkConfirm()
  if (!url || typeof window === 'undefined') return
  window.open(url, '_blank', 'noopener,noreferrer')
}
